import RecognitionEmployeeProfile from "./RecognitionEmployeeProfile";

export default RecognitionEmployeeProfile;
